import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'
import type { UseSuccessModalReturn } from '@percent/domain/giving'

export function SuccessModal({ isOpen, closeModal }: Pick<UseSuccessModalReturn, 'isOpen' | 'closeModal'>) {
  const { t } = useTranslation()

  return (
    <Modal borderRadiiSize="xlarge" onClose={closeModal} open={isOpen}>
      <AcknowledgeModal
        result="positive"
        title={t('volunteering.opportunity.form.common.successModal.title')}
        description={t('volunteering.opportunity.form.common.successModal.description')}
        buttonText={t('button.close')}
        handleClose={closeModal}
      />
    </Modal>
  )
}
